module.exports = __webpack_public_path__ + "img/book_analysis.bc5d9dff.png";